import React from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { logout } from "../../actions/customer";
import { showErrorSnackbar } from "../../actions/snackbar";
import useStyles from "./styles";

const AccountWrapper = ({ children, title = "My Account" }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();

  const handleLogout = () => {
    dispatch(logout());
    dispatch(showErrorSnackbar("You are logged out!"));
  };

  const menuItems = [
    {
      id: "profile",
      label: "My Profile",
      path: "/profile",
      icon: "fa fa-user",
    },
    {
      id: "orders",
      label: "My Orders",
      path: "/orders",
      icon: "fa fa-shopping-bag",
    },
    {
      id: "addresses",
      label: "My Addresses",
      path: "/my-addresses",
      icon: "fa fa-map-marker",
    },
  ];

  return (
    <div className={classes.accountContainer}>
      <div className={classes.accountHeader}>
        <div className="container">
          <h1 className={classes.accountTitle}>{title}</h1>
        </div>
      </div>

      <div className="container">
        <div className={classes.accountContent}>
          <div className={classes.sidebar}>
            <div className={classes.sidebarHeader}>
              <div className={classes.userInfo}>
                <div className={classes.userAvatar}>
                  <i className="fa fa-user"></i>
                </div>
                <div className={classes.userDetails}>
                  <h3 className={classes.userName}>Welcome Back!</h3>
                  <p className={classes.userEmail}>Manage your account</p>
                </div>
              </div>
            </div>

            <nav className={classes.sidebarNav}>
              {menuItems.map((item) => (
                <Link
                  key={item.id}
                  to={item.path}
                  className={`${classes.navItem} ${
                    location.pathname === item.path ? classes.navItemActive : ""
                  }`}
                >
                  <i className={`${item.icon} ${classes.navIcon}`}></i>
                  <span className={classes.navLabel}>{item.label}</span>
                </Link>
              ))}

              <div className={classes.navDivider}></div>

              <button
                className={`${classes.navItem} ${classes.logoutButton}`}
                onClick={handleLogout}
              >
                <i className={`fa fa-sign-out ${classes.navIcon}`}></i>
                <span className={classes.navLabel}>Log Out</span>
              </button>
            </nav>
          </div>

          <div className={classes.mainContent}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default AccountWrapper;
